module.exports = __webpack_public_path__ + "aa69821357b9dc7672e1c2c5a7fef783.jpg";